// Client Tabs

export const CLIENT_TAB_CONFIG = [
  {
    value: 'Perfil 360',
    label: 'Perfil 360',
    icon: 'account_circle',
    iconSize: 20,
    filled: true
  },
  {
    value: 'Detalles',
    label: 'Detalles',
    icon: 'dehaze',
    iconSize: 20,
    filled: false
  } //,
  // {
  //   value: 'Historial', ////OUT OF SCOPE
  //   label: 'Historial',
  //   icon: 'schedule',
  //   iconSize: 20,
  //   filled: false
  // }
]

// Colores del Client Dashboard

export const CLIENT_DASHBOARD_COLORS = {
  primaryIcon: '#27588D',
  secondaryIcon: '#FF8A3D',
  commercialIcon: '#4B6EA9',
  sectionTitle: '#202020',
  sectionSubtitle: '#606060'
}

//Tamaños de iconos

export const CLIENT_DASHBOARD_ICON_SIZES = {
  default: 20,
  large: 22
}

// SectionCollapse

export const SECTION_COLLAPSE_STYLES = {
  titleWeight: 700,
  titleColor: CLIENT_DASHBOARD_COLORS.sectionTitle,
  subtitleColor: CLIENT_DASHBOARD_COLORS.sectionSubtitle,
  toggleIconSize: CLIENT_DASHBOARD_ICON_SIZES.large
}

// Commercial Summary

export const COMMERCIAL_CARDS = [
  {
    key: 'orders',
    title: 'PEDIDOS',
    icon: 'shopping_cart'
  },
  {
    key: 'invoiced',
    title: 'FACTURADO',
    icon: 'receipt_long'
  },
  {
    key: 'delivered',
    title: 'ENTREGADO',
    icon: 'local_shipping'
  },
  {
    key: 'collected',
    title: 'COBRADO',
    icon: 'attach_money'
  },
  {
    key: 'returned',
    title: 'DEVUELTO',
    icon: 'replay'
  }
]

export const COMMERCIAL_CARD_STYLES = {
  iconColor: CLIENT_DASHBOARD_COLORS.commercialIcon,
  iconSize: CLIENT_DASHBOARD_ICON_SIZES.default,
  iconBg: '#E9EFF6',
  valueColor: '#1F4E8C'
}

// Frequency Summary

export const FREQUENCY_CARDS = [
  {
    key: 'lastOrderDate',
    title: 'FECHA DE ÚLTIMO PEDIDO',
    icon: 'event_available'
  },
  {
    key: 'daysFromLastOrder',
    title: 'TIEMPO DESDE ÚLTIMO PEDIDO',
    icon: 'event_available'
  },
  {
    key: 'ordersCount',
    title: 'PEDIDOS REALIZADOS',
    icon: 'shopping_bag_speed'
  },
  {
    key: 'averageTicket',
    title: 'TICKET PROMEDIO',
    icon: 'confirmation_number'
  }
]

export const FREQUENCY_CARD_STYLES = {
  iconColor: CLIENT_DASHBOARD_COLORS.commercialIcon,
  valueColor: '#1F4E8C',
  iconBg: '#E9EFF6'
}

export const FREQUENCY_STATUS_COLORS = {
  good: '#2E7D32',
  warning: '#ED6C02',
  danger: '#D32F2F'
}

// Visit Summary

export const VISIT_SUMMARY_CARDS = {
  planVsReal: {
    title: 'VISITAS: PLANEADA VS REAL'
  },
  assignedUsers: {
    title: 'USUARIOS ASIGNADOS',
    viewAllLabel: 'Lista completa'
  },
  visitedCount: {
    title: 'VECES VISITADO',
    subtitle: 'Próxima visita:'
  },
  effectiveness: {
    title: 'EFECTIVIDAD',
    subtitle: 'Última actividad:'
  }
}

export const VISIT_COLORS = {
  plan: '#5B7DB1',
  real: '#FF8A3D',
  primary: '#4B6EA9',
  textSecondary: '#606060',
  muted: '#8E909B'
}

export const VISIT_LIMITS = {
  assignedUsersPreview: 3,
  defaultMaxVisits: 1000
}

// Goals Summary

export const GOALS_SUMMARY = {
  salesProgress: {
    title: 'AVANCE DE VENTAS'
  },
  counter: {
    actionLabel: 'Ver listado completo'
  }
}

export const GOALS_COLORS = {
  progressBg: '#C9D3E2',
  progressFill: '#FF8A3D',
  action: '#4B6EA9',
  border: '#E4E4E4',
  titleColor: CLIENT_DASHBOARD_COLORS.sectionSubtitle
}

export const GOALS_DIMENSIONS = {
  cardHeight: 141,
  cardWidth: 718,
  progressHeight: 30,
  progressRadius: 7
}

// Client Header

export const CLIENT_HEADER_COLORS = {
  title: '#50739A',
  label: '#515465',
  value: '#50739A',
  muted: '#6B6F7A',
  creditMain: '#1F1F1F',
  creditSecondary: '#8A8A8A'
}

export const CLIENT_HEADER_LAYOUT = {
  metaMaxWidth: 250,
  creditMinWidth: 220
}

export const CLIENT_STATUS = {
  active: {
    label: 'ACTIVO',
    className: 'chip chip--active'
  },
  inactive: {
    label: 'DESHABILITADO',
    className: 'chip chip--inactive'
  },
  delinquent: {
    label: 'MOROSO',
    className: 'chip chip--danger'
  }
}

export const DATE_PICKER_SETTINGS = {
  months: [
    ['Enero', 'Ene'],
    ['Febrero', 'Feb'],
    ['Marzo', 'Mar'],
    ['Abril', 'Abr'],
    ['Mayo', 'May'],
    ['Junio', 'Jun'],
    ['Julio', 'Jul'],
    ['Agosto', 'Ago'],
    ['Septiembre', 'Sep'],
    ['Octubre', 'Oct'],
    ['Noviembre', 'Nov'],
    ['Diciembre', 'Dic']
  ],
  weekDays: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
  weekStartDayIndex: 1
}

// Status options for order, refund, delivery, and charge activities
export const ACTIVITY_STATUS_OPTIONS = {
  // Order / Refund / Charge (shared)
  received: {
    label: 'RECIBIDO',
    className: 'order-status received-style'
  },
  cancelled: {
    label: 'CANCELADO',
    className: 'order-status cancelled-style'
  },
  sent: {
    label: 'ENVIADO',
    className: 'order-status sent-style'
  },
  // Order only
  dispatched: {
    label: 'DESPACHADO',
    className: 'order-status dispatched-style'
  },
  billed: {
    label: 'FACTURADO',
    className: 'order-status billed-style'
  },
  tobebilled: {
    label: 'POR FACTURAR',
    className: 'order-status pending-bill-style'
  },
  ontheway: {
    label: 'EN CAMINO',
    className: 'order-status dispatched-style'
  },
  partial: {
    label: 'PARCIAL',
    className: 'order-status partial-style'
  },
  annulled: {
    label: 'ANULADO',
    className: 'order-status annulled-style'
  },
  // Delivery
  open: {
    label: 'POR ENTREGAR',
    className: 'delivery-status delivery-open-style'
  },
  delivery_receipt: {
    label: 'ENTREGADO',
    className: 'delivery-status delivery-received-style'
  },
  partial_delivery_receipt: {
    label: 'PARCIAL',
    className: 'delivery-status delivery-received-style'
  },
  partial_refund: {
    label: 'PARCIAL',
    className: 'delivery-status delivery-received-style'
  },
  refund: {
    label: 'RECHAZADO',
    className: 'delivery-status delivery-received-style'
  }
}

// Map from ACTIVITY_STATUS_OPTIONS labels to their keys (for query params)
export const ACTIVITY_STATUS_LABEL_TO_KEY = Object.fromEntries(
  Object.entries(ACTIVITY_STATUS_OPTIONS).map(([key, { label }]) => [label, key])
)

export const OPEN_URL_WINDOW = (url) => {
  window.open(url, '_blank')
}
